import { render } from "./AlbumCard.vue?vue&type=template&id=1df549b4&scoped=true"
import script from "./AlbumCard.vue?vue&type=script&lang=js"
export * from "./AlbumCard.vue?vue&type=script&lang=js"

import "./AlbumCard.vue?vue&type=style&index=0&id=1df549b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df549b4"]])

export default __exports__